import { SeriesType } from '@components/trade/rfx/tradingview/constants'
import { CustomTimezoneId } from '@public/charting_library/charting_library'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ChartOptionsStore {
  timezone: CustomTimezoneId | 'exchange'
  barType: SeriesType
  dateRange: [Date | null, Date | null]
  interval: string
  useDataRange: boolean
  showDetails: boolean
  showBottomToolbar: boolean
  hideTopToolbar: boolean
  hideLegend: boolean
  hideSideToolbar: boolean
  smallButtons: boolean
  updateKey: <K extends keyof ChartOptionsStore>(
    key: K,
    value: ChartOptionsStore[K],
  ) => void
  set: (
    partial:
      | ChartOptionsStore
      | Partial<ChartOptionsStore>
      | ((state: ChartOptionsStore) => ChartOptionsStore),
    replace?: false | undefined,
  ) => void
}

export const multichartSettingsDefaults: Pick<
  ChartOptionsStore,
  | 'timezone'
  | 'barType'
  | 'dateRange'
  | 'interval'
  | 'useDataRange'
  | 'showDetails'
  | 'showBottomToolbar'
  | 'hideTopToolbar'
  | 'hideLegend'
  | 'hideSideToolbar'
  | 'smallButtons'
> = {
  timezone: 'exchange',
  barType: SeriesType.Candles,
  dateRange: [null, null],
  interval: '1H',
  useDataRange: false,
  showDetails: true,
  showBottomToolbar: true,
  hideTopToolbar: false,
  hideLegend: false,
  hideSideToolbar: false,
  smallButtons: false,
}

export const useMultiChartSettings = create<ChartOptionsStore>()(
  persist(
    (set) => ({
      set,
      updateKey: (key, value) => {
        set({ [key]: value })
      },
      ...multichartSettingsDefaults,
    }),
    {
      name: 'multichart-settings',
      partialize: () => () => {},
    },
  ),
)
